<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="enquiry-page pt-227 pb-100">
    <div class="container">
      <div class="section-title mw-600">
        <span class="top-title">Business Enquiry</span>
        <h2>Contact Us for Business Opportunities</h2>
      </div>
      <form class="enquiry-form" @submit.prevent="submitForm">
        <div class="form-group">
          <label for="name">Name / Brand Name</label>
          <input id="name" v-model="name" type="text" required />
        </div>
        <div class="form-group">
          <label for="celebrity">Select Celebrity</label>
          <select id="celebrity" v-model="celebrity" required>
            <option value="">Select Celebrity</option>
            <option value="Sharanya Shetty">Sharanya Shetty</option>
            <option value="Rashmi Prabhakar">Rashmi Prabhakar</option>
            <option value="Aditi Prabhudeva">Aditi Prabhudeva</option>
            <option value="Reeshma Nanaiah">Reeshma Nanaiah</option>
            <option value="Parvati Nair">Parvati Nair</option>
            <option value="Sudhan D">Sudhan D</option>
          </select>
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input id="email" v-model="email" type="email" required />
        </div>
        <div class="form-group">
          <label for="message">Enter your Enquiry Details</label>
          <textarea id="message" v-model="message" required></textarea>
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  </div>
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "BusinessEnquiryPage",
  components: { MainNavbar, MainFooter },
  setup() {
    const name = ref("");
    const email = ref("");
    const celebrity = ref("");
    const message = ref("");
    const whatsappNumber = "919113229933"; // Replace with your WhatsApp number
    const submitForm = () => {
      const text = `Business Enquiry  Name/Brand: ${name.value} Email: ${email.value} Celebrity: ${celebrity.value} Details: ${message.value}`;
      const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
      window.open(url, '_blank');
    };
    return { name, email, celebrity, message, submitForm };
  },
});
</script>

<style scoped>
.enquiry-page {
  padding: 180px 20px 20px 20px;
}
.section-title.mw-600 {
  max-width: 600px;
  margin: 0 auto 40px auto;
  text-align: center;
}
.enquiry-form {
  max-width: 500px;
  margin: 0 auto;
  background: #fec4abff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.04);
}
.form-group {
  margin-bottom: 20px;
}
label {
  display: block;
  margin-bottom: 6px;
  color: #333;
}
input, textarea, select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
button[type="submit"] {
  width: 100%;
  padding: 10px;
  background: #f66122ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}
</style>
